import { useEffect, useRef } from 'react'
import { FAST_POLL_MS } from '../lib/polling'

export type AutoRefreshOptions = {
  intervalMs?: number
  /** Skip the tick while the last one is still in flight, instead of stacking requests. */
  busy?: boolean
}

/**
 * Re-reads a screen's data while something is moving on the server — a scan the user started from
 * here or from another tab. Stops the moment `active` goes false, so a settled hub is silent.
 */
export function useAutoRefresh(
  active: boolean,
  onTick: () => void,
  { intervalMs = FAST_POLL_MS, busy = false }: AutoRefreshOptions = {},
) {
  const tick = useRef(onTick)
  tick.current = onTick

  const isBusy = useRef(busy)
  isBusy.current = busy

  useEffect(() => {
    if (!active) return
    const timer = setInterval(() => {
      if (!isBusy.current) tick.current()
    }, intervalMs)
    return () => clearInterval(timer)
  }, [active, intervalMs])
}
